export default __webpack_public_path__ + "static/hip-video-2c8708603c723e8a9120d4dd6575a5f9.jpg";